import React from 'react'

import { StyledPill } from './DiscoverNewContentPill.styles'

const DiscoverNewContentPill: React.FCC = () => {
  return <StyledPill variant="secondary">New</StyledPill>
}

export default DiscoverNewContentPill
